/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import AuthSlice from "./slices/auth.slice";
import EventSlice from "./slices/event.slice";
import ContainerSlice from "./slices/containers.slice";
import VideochatSlice from "./slices/videochat.slice";
import NavigationHistorySlice from "./slices/navigation.slice";
import ActivityLogSlice from "./slices/activity-log.slice";
import ArrAppointmentsSlice from "./slices/appointment.slice";

import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";

import storage from "redux-persist/lib/storage";
import NotificationSlice from "./slices/notification.slice";

/**
 * Redux persist configuration for state persistence in localStorage.
 */
const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

/**
 * Root reducer combining all Redux slices for medical record system state.
 * Includes auth, events, containers, notifications, videochat, navigation, and activity logs.
 */
const rootReducer = combineReducers({
  auth: AuthSlice.reducer,
  event: EventSlice.reducer,
  container: ContainerSlice.reducer,
  notificationAction: NotificationSlice.reducer,
  videochat: VideochatSlice.reducer,
  navigationHistory: NavigationHistorySlice.reducer,
  activityLog: ActivityLogSlice.reducer,
  arrAppointments: ArrAppointmentsSlice.reducer,
});

/**
 * Root reducer type for TypeScript type inference across the application.
 */
export type RootReducer = ReturnType<typeof rootReducer>;

const persistedReducer = persistReducer<RootReducer>(persistConfig, rootReducer);

/**
 * Configured Redux store with persistence and middleware.
 * Ignores serialization checks for redux-persist actions.
 */
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

/*const store = configureStore({
    reducer: {
      auth: AuthSlice.reducer,
      error: ErrorSlice.reducer,
      container: ContainerSlice.reducer
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      })
});*/

export const authAction = AuthSlice.actions;
export const eventAction = EventSlice.actions;
export const containerAction = ContainerSlice.actions;
export const notificationAction = NotificationSlice.actions;
export const videochatAction = VideochatSlice.actions;
export const navigationHistoryAction = NavigationHistorySlice.actions;
export const activityLogAction = ActivityLogSlice.actions;
export const arrAppointmentsAction = ArrAppointmentsSlice.actions;

export default store;

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

